const pagesIndividualLookupResourcesEn = {
  accounts: {
    detail: {
      actualRoleName: 'Role',
      app: 'App',
      basicInfo: 'Basic information',
      category: 'Category',
      createdAt: 'Created',
      displayName: 'Display name',
      lastSignIn: 'Last sign-in',
      mfa: 'MFA',
      tenantName: 'Tenant'
    },
    headers: {
      actualRoleName: 'Role',
      app: 'App',
      category: 'Category',
      createdAt: 'Created',
      displayName: 'Display name',
      lastSignIn: 'Last sign-in',
      mfa: 'MFA',
      tenantName: 'Tenant'
    },
    mfa: {
      disabled: 'Off',
      enabled: 'On'
    },
    title: 'Software'
  },
  certifications: {
    detail: {
      basicInfo: 'Basic information',
      certificationKind: 'Kind',
      certificationNumber: 'Certificate No.',
      lastRenewalDate: 'Last renewed',
      renewalDeadline: 'Renewal deadline',
      validTo: 'Valid until'
    },
    headers: {
      certificationKind: 'Kind',
      expireAt: 'Valid until',
      lastUpdated: 'Last renewed',
      name: 'Certification',
      number: 'Certificate No.',
      renewBy: 'Renewal deadline'
    },
    title: 'Certifications'
  },
  common: {
    backToList: 'Back to list',
    backToLookup: 'Back to Inquiry & Reference',
    empty: 'No items to display',
    filterTabsLabel: 'Filter',
    forbidden: {
      backToLookup: 'Back to Inquiry & Reference',
      description: "You don't have permission to view this page.",
      title: 'Access denied'
    },
    loading: 'Loading…',
    search: 'Search'
  },
  devices: {
    detail: {
      assetTag: 'Asset tag',
      basicInfo: 'Basic information',
      deviceTag: 'Device tag',
      genre: 'Type',
      model: 'Model'
    },
    headers: {
      assetTag: 'Asset tag',
      deviceTag: 'Device tag',
      genre: 'Type',
      model: 'Model',
      name: 'Device'
    },
    tabs: {
      self: 'My devices'
    },
    title: 'Devices'
  },
  equipments: {
    detail: {
      assetTag: 'Asset tag',
      basicInfo: 'Basic information',
      equipmentTypeName: 'Type',
      manufacturer: 'Manufacturer',
      modelNumber: 'Model number',
      productName: 'Product name',
      serialNumber: 'Serial number',
      status: 'Status'
    },
    headers: {
      assetTag: 'Asset tag',
      equipmentTypeName: 'Type',
      manufacturer: 'Manufacturer',
      modelNumber: 'Model number',
      name: 'Equipment',
      status: 'Status'
    },
    status: {
      assigned: 'Assigned',
      available: 'Available',
      decommissioned: 'Decommissioned',
      placed: 'Placed at site',
      under_repair: 'Under repair'
    },
    tabs: {
      self: 'My equipment'
    },
    title: 'Equipment'
  },
  places: {
    headers: {
      code: 'Code',
      name: 'Place',
      status: 'Status'
    },
    title: 'Places'
  }
};
export default pagesIndividualLookupResourcesEn;